export type ApiResponseError = {
  attribute?: string;
  code?: string;
  detail?: string;
  pointer?: string;
};

export interface V3ErrorResponse {
  detail?: string;
  errors: ApiResponseError[];
}

export const buildV3Error = (
  ...errors: Array<string | ApiResponseError>
): V3ErrorResponse => ({
  errors: errors.map((e) => (typeof e === 'string' ? { detail: e } : e)),
});

/**
 * Error class for API request failures.
 *
 * Contains the original Response object for access to status, headers, etc.
 * Also carries structured errors from the response body when available.
 */
export class ApiError extends Error {
  response: Response;
  errors: ApiResponseError[];

  constructor(
    message: string,
    response: Response,
    errors: ApiResponseError[] = []
  ) {
    super(message);
    this.name = 'ApiError';
    this.response = response;
    this.errors = errors;
  }
}
